import { render, staticRenderFns } from "./ReceivedOrdersList.vue?vue&type=template&id=4b1a43c2&scoped=true"
import script from "./ReceivedOrdersList.vue?vue&type=script&lang=js"
export * from "./ReceivedOrdersList.vue?vue&type=script&lang=js"
import style0 from "./ReceivedOrdersList.vue?vue&type=style&index=0&id=4b1a43c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1a43c2",
  null
  
)

export default component.exports